import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { SalesService } from '../../../services/sales.service';
import { InventoryService } from '../../../services/inventory.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProductListLookupComponent } from '../product-list-lookup/product-list-lookup.component';
import { MessageService } from 'primeng/api';
import { CustomerService } from '../../../services/customer.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-cust-product-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './add-cust-product-lookup.component.html',
  styleUrl: './add-cust-product-lookup.component.scss'
})
export class AddCustProductLookupComponent implements OnInit {

  constructor(private salesService: SalesService, private inventoryService: InventoryService, private dialogService: DialogService,
    public ref: DynamicDialogRef, private config: DynamicDialogConfig, private messageService: MessageService, private customerService: CustomerService) { }

  submitted: boolean = false;
  loader: boolean = false;
  filterProductList: any[] = [];
  previewImage: string = "./assets/no-image.jpg";

  ngOnInit(): void {
    this.CustProductForm.patchValue({
      CustomerCode: this.config.data?.CustomerCode,
      CustomerId: this.config.data?.CustomerId,
    })
  }

  CustProductForm = new FormGroup({
    CustomerProductCode: new FormControl('', Validators.required),
    ProductId: new FormControl('', Validators.required),
    ProductCode: new FormControl('', Validators.required),
    CustomerId: new FormControl('', Validators.required),
    CustomerCode: new FormControl('', Validators.required),
    Description: new FormControl(''),
    Category: new FormControl(''),
    UOM: new FormControl(''),
    Type: new FormControl(''),
  });

  get formControls() {
    return this.CustProductForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.CustProductForm.invalid) {
      isValid = false;
    }
    return isValid;
  }

  async setProduct(data: any) {
    var productData = data.value;
    this.loader = true;
    productData = await this.getProductById(productData.productId);
    this.getProductTypeNameByCode(productData.productType);
    this.CustProductForm.patchValue({
      ProductId: productData.productId,
      ProductCode: productData.productCode,
      Description: productData.productName,
      Category: productData.category.categoryCode + " - " + productData.category.categoryName,
      UOM: productData.unitsOfMeasure,
    })


    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
  }

  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => {
          reject(error)
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Unable to retrieve product details.' });
          this.loader = false;
        },
      });
    });
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getProductTypeNameByCode(productTypeCode: string) {
    this.inventoryService.getProductByType(productTypeCode).subscribe({
      next: (data: any) => {
        this.loader = false;
        if (Array.isArray(data) && data.length > 0) {
          const productType = data[0];
          if (productType.productTypeName) {
            this.CustProductForm.controls.Type.setValue(productType.productTypeName);
          } else {
            this.CustProductForm.controls.Type.setValue('Unknown');
          }
        } else {
          this.CustProductForm.controls.Type.setValue('Unknown');
        }
      },
      error: (error: any) => {
        this.loader = false;
        console.error('Error fetching product type name:', error);
        this.CustProductForm.controls.Type.setValue('Error fetching name');
      }
    });
  }

  save(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    this.loader = true;
    data.CreatedBy = localStorage.getItem("username");
    this.customerService.CreateCustomerProduct(data).subscribe({
      next: (data: any) => {
        this.loader = false;
        if (data.success) {
          this.ref.close(true);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.CustProductForm.controls.CustomerProductCode.setValue('');
        }

      },
      error: (error: any) => {
        this.loader = false;
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to save.' });
      }
    });
  }

  showProductList() {
    const productDialogRef = this.dialogService.open(ProductListLookupComponent, {
      header: `Product List`,
      width: '60%',
    });

    productDialogRef.onClose.subscribe((ProductData: string) => {
      if (ProductData) {
        const data = {
          value: ProductData
        };
        this.setProduct(data);
      }
    });
  }


}
